/* import __COLOCATED_TEMPLATE__ from './amendment-banner.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */

import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  formattedAmendmentDate: string;
}
interface Signature {
  Element: any;
  Args: Args;
}

const AmendmentBanner = templateOnlyComponent<Signature>();
export default AmendmentBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::AmendmentBanner': typeof AmendmentBanner;
    'banners/amendment-banner': typeof AmendmentBanner;
  }
}
